(function () {
  "use strict";
  const t = "[data-image-id]",
    e = "product-images",
    s = "[data-section-id]",
    i = "[data-thumb-item]",
    o = "[data-thumb-link]",
    r = "[data-thumbs-slider]",
    n = "data-active-media",
    a = "data-media-id",
    c = "is-active",
    p = "[data-thumbs-prev]",
    d = "[data-thumbs-next]";

  customElements.get("product-thumbs") ||
    customElements.define(
      "product-thumbs",
      class extends HTMLElement {
        constructor() {
          super();
          this.container = this.closest(s);
          this.productImages = this.container.querySelectorAll(t);
          this.productImagesContainer = this.container.querySelector(e);
          this.productThumbs = this.container.querySelectorAll(i);
          this.thumbSlider = this.querySelector(r);
          this.thumbLinks = this.querySelectorAll(o);
          this.prevButton = this.querySelector(p);
          this.nextButton = this.querySelector(d);
        }
        connectedCallback() {
          this.handleEvents();
          this.preloadImagesOnHover();
          this.activeMediaObserver();
          this.handleNavButtons();
        }
        disconnectedCallback() {
          this.observer && this.observer.disconnect();
        }
        activeMediaObserver() {
          this.observer = new MutationObserver((t) => {
            for (const e of t)
              "attributes" === e.type &&
                e.attributeName == n &&
                this.setActiveThumb();
          });
          this.observer.observe(this.productImagesContainer, {
            attributes: !0,
            childList: !1,
            subtree: !1,
          });
        }
        handleEvents() {
          this.thumbLinks?.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              const s = t.closest(i),
                o = t.getAttribute(a);
              if (!o || s?.classList.contains(c)) return;
              this.dispatchEvent(
                new CustomEvent("theme:media:select", {
                  bubbles: !0,
                  detail: { id: o },
                })
              );
            });
          });
        }
        handleNavButtons() {
          if (!this.thumbSlider) return;
          const scrollByAmount = () => {
            const thumb = this.thumbSlider.querySelector(i);
            if (!thumb) return Math.max(this.thumbSlider.clientHeight / 3, 80);
            const styles = window.getComputedStyle(thumb);
            const margin =
              parseFloat(styles.marginBottom) ||
              parseFloat(styles.marginRight) ||
              0;
            return thumb.offsetHeight + margin;
          };
          this.prevButton?.addEventListener("click", () => {
            this.thumbSlider.scrollBy({
              top: -scrollByAmount(),
              left: -scrollByAmount(),
              behavior: "smooth",
            });
          });
          this.nextButton?.addEventListener("click", () => {
            this.thumbSlider.scrollBy({
              top: scrollByAmount(),
              left: scrollByAmount(),
              behavior: "smooth",
            });
          });
        }
        preloadImagesOnHover() {
          this.thumbLinks?.forEach((t) => {
            t.addEventListener("mouseover", () => {
              const e = t.getAttribute(a);
              this.productImagesContainer
                .querySelector(`[${a}="${e}"] img`)
                ?.setAttribute("loading", "eager");
            });
          });
        }
        setActiveThumb() {
          const t = this.productImagesContainer.getAttribute(n),
            e = this.querySelector(`[${a}="${t}"]`);
          this.querySelectorAll(`${i}.${c}`).forEach((item) => {
            item.classList.remove(c);
            item.querySelector(o)?.setAttribute("aria-current", "false");
          });
          e?.parentNode.classList.add(c);
          e?.setAttribute("aria-current", "true");
          requestAnimationFrame(() => {
            this.scrollToThumb();
          });
        }
        scrollToThumb() {
          const t = this.thumbSlider;
          if (t) {
            const e = t.querySelector(`.${c}`);
            if (!e) return;
            const s = t.scrollTop,
              i = t.scrollLeft,
              o = t.offsetWidth,
              r = t.offsetHeight,
              n = s + r,
              a = i + o,
              d = e.offsetTop,
              h = e.offsetLeft,
              l = e.offsetWidth,
              u = e.offsetHeight,
              m = s > d,
              b = i > h,
              v = h + l > a,
              f = d + u > n || m,
              p = v || b,
              g = window.theme.isMobile();
            if (f || p) {
              let e = d - r + u,
                s = h - o + l;
              m && (e = d);
              v &&
                g &&
                (s += parseInt(window.getComputedStyle(t).paddingRight));
              b &&
                ((s = h),
                g &&
                  (s -= parseInt(window.getComputedStyle(t).paddingLeft)));
              t.scrollTo({ top: e, left: s, behavior: "smooth" });
            }
          }
        }
      }
    );
})();
